export const bounceOut = {
  0: {
    opacity: 1,
    scale: 1,
  },
  0.2: {
    scale: 0.9,
  },
  0.5: {
    opacity: 1,
    scale: 1.11,
  },
  0.55: {
    scale: 1.11,
  },
  1: {
    opacity: 0,
    scale: 0.3,
  },
};

export const bounceOutUp = {
  0: {
    opacity: 1,
    translateY: 0,
  },
  0.2: {
    opacity: 1,
    translateY: -10,
  },
  0.4: {
    translateY: 20,
  },
  0.45: {
    translateY: 20,
  },
  0.55: {
    opacity: 1,
  },
  1: {
    opacity: 0,
    translateY: -800,
  },
};

export const bounceOutDown = {
  0: {
    opacity: 1,
    translateY: 0,
  },
  0.2: {
    opacity: 1,
    translateY: 10,
  },
  0.4: {
    translateY: -20,
  },
  0.45: {
    translateY: -20,
  },
  0.55: {
    opacity: 1,
  },
  1: {
    opacity: 0,
    translateY: 800,
  },
};

export const bounceOutRight = {
  0: {
    opacity: 1,
    translateX: 0,
  },
  0.2: {
    opacity: 1,
    translateX: 10,
  },
  0.4: {
    translateX: -20,
  },
  0.45: {
    translateX: -20,
  },
  0.55: {
    opacity: 1,
  },
  1: {
    opacity: 0,
    translateX: 600,
  },
};

export const bounceOutLeft = {
  0: {
    opacity: 1,
    translateX: 0,
  },
  0.2: {
    opacity: 1,
    translateX: -10,
  },
  0.4: {
    translateX: 20,
  },
  0.45: {
    translateX: 20,
  },
  0.55: {
    opacity: 1,
  },
  1: {
    opacity: 0,
    translateX: -600,
  },
};
